import { useMemo } from "react";
import { createCalculator } from "../../calculator";

export const useCreatedCalculator: typeof createCalculator = (...args) => {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	return useMemo(() => createCalculator(...args), [...args]);
};
